import { SpeechBubble } from './components/SpeechBubble.js';
import { createMachine, interpret } from 'xstate';

class OneBubbleTutorial extends EventTarget{
    constructor() {
        super();
        this.bubble = new SpeechBubble();
        this.bubble_html = [];
    }

    switchToBubble(index) {
        const container = document.createElement('div')
        container.classList.add('how-it-works-modal')

        const title = document.createElement('h2')
        title.textContent = 'How It Works'
        title.classList.add('title')
        container.appendChild(title)

        const divider = document.createElement('hr')
        container.appendChild(divider)

        const description = document.createElement('div')
        description.innerHTML = this.bubble_html[index]
        description.classList.add('description')
        container.appendChild(description)

        const button = document.createElement('button')
        button.textContent = 'close'
        button.classList.add('close')
        button.addEventListener('click', ()=>{
            this.state.send("TOGGLE")
        })
        container.appendChild(button)

        this.bubble.setChildren(container);

        if (this.bubble.isVisible()) {
            this.bubble.fadeInSpans();
        }
    }

    // Hide the tutorial window
    clear(context, event) {
        this.bubble.popOut();
    }

    // Make the tutorial window visible
    open (context, event) {
        this.bubble.popIn();
    }
}

export class LandingPageTutorial extends OneBubbleTutorial {

    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open'],
                                RESET: {
                                    target: 'initial',
                                    actions: ['onReset'],
                                },
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden',
                            RESET: {
                                target: 'initial',
                                actions: ['onReset', 'clear'],
                            },
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {
                        on: {
                            NEXT: 'state_explanation',
                            ZOOM_IN: 'state_explanation',
                            LOAD_COUNTIES: 'county_explanation',
                            ENTER_MAP: 'map_explanation',
                        },
                        entry: ["onFirstView"],
                    },
                    state_explanation: {
                        on: {
                            ZOOM_OUT: 'first_view',
                            LOAD_COUNTIES: 'county_explanation',
                            ENTER_MAP: 'map_explanation',
                            RESET: {
                                target: 'first_view',
                                actions: ['onReset'],
                            },
                        },
                        entry: ["onStateExplanation"],
                    },
                    county_explanation: {
                        on: {
                            LOAD_ZIPS: 'zip_explanation',
                            ENTER_MAP: 'map_explanation',
                            RESET: {
                                target: 'first_view',
                                actions: ['onReset'],
                            },
                        },
                        entry: ["onCountyExplanation"],
                    },
                    zip_explanation: {
                        on: {
                            LOAD_COUNTIES: 'county_explanation',
                            ENTER_MAP: 'map_explanation',
                            RESET: {
                                target: 'first_view',
                                actions: ['onReset'],
                            },
                        },
                        entry: ["onZipExplanation"],
                    },
                    map_explanation: {
                        on: {
                            SELECT_HOME: 'select_election_explanation',
                            LEAVE_MAP: 'zip_explanation',
                            LOAD_ZIPS: 'zip_explanation',
                            LOAD_COUNTIES: 'county_explanation',
                            RESET: {
                                target: 'first_view',
                                actions: ['onReset'],
                            },
                        },
                        entry: ["onMapExplanation"],
                    },
                    select_election_explanation: {
                        on: {
                            LEAVE_MAP: 'zip_explanation',
                            LOAD_ZIPS: 'zip_explanation',
                            RESET: {
                                target: 'first_view',
                                actions: ['onReset'],
                            },
                        },
                        entry: ["onSelectElectionExplanation"],
                    },
                }
            }
        },
    };


    constructor() {
        super();
        const scope = this;

        // Define the content that will be shown in the speech bubble at each step of the tutorial
        this.bubble_html = [
            "Who can you vote for? <br> <br> Enter your address in the search bar or click on the United States to find out",
            "Select the state you wish to explore.",
            "Select your county will narrow your search.</span>",
            "Choose your zip code for elections specific in your area.</span>",
            "Filter elections by year and type, Explore the various districts you vote in. Select an election on the right to see a list of candidates.",
            "Select an election on the right to see your candidates or explore your districts on the left.",
        ];

        // Attach bubble to parent
        document.querySelector("#how-it-works").prepend(this.bubble.element);

        // TODO: Detect veteran users with cookies?
        // Connect state machine actions to the functions in this class
        this.stateMachine = createMachine(LandingPageTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => { this.onFirstView( context, event ) },
                onStateExplanation: (context, event) => { this.onStateExplanation( context, event ) },
                onCountyExplanation: (context, event) => { this.onCountyExplanation( context, event ) },
                onZipExplanation: (context, event) => { this.onZipExplanation( context, event ) },
                onMapExplanation: (context, event) => { this.onMapExplanation( context, event ) },
                onSelectElectionExplanation: (context, event) => { this.onSelectElectionExplanation( context, event ) },
                onReset: (context, event) => { this.onReset ( context, event ) },
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state))
            .start();

        // Setup callback on question mark button
        // const button = document.querySelector(".walkthrough-question-mark");
        // button.addEventListener("click", () => scope.state.send("TOGGLE"));
    }

    // Actions
    // These are the functions that run on state transitions
    onFirstView(context, event) {
        this.switchToBubble(0);
        this.dispatchEvent(new CustomEvent("firstview", {context, event}));
    }

    onStateExplanation(context, event) {
        this.switchToBubble(1);
        this.dispatchEvent(new CustomEvent("stateexplanation", {context, event}));
    }

    onCountyExplanation(context, event) {
        this.switchToBubble(2);

        this.dispatchEvent(new CustomEvent("countyexplanation", {context, event}));
    }

    onZipExplanation(context, event) {
        this.switchToBubble(3);

        this.dispatchEvent(new CustomEvent("zipexplanation", {context, event}));
    }

    onMapExplanation(context, event) {
        this.switchToBubble(4);

        this.dispatchEvent(new CustomEvent("mapexplanation", {context, event}));
    }

    onSelectElectionExplanation(context, event) {
        this.switchToBubble(5);

        this.dispatchEvent(new CustomEvent("selectelectionexplanation", {context, event}));
    }

    onReset(context, event) {
        this.dispatchEvent(new CustomEvent("reset", {context, event}));
    }
}

export class OSMTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden'
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {
                        on: {
                            SELECT_HOME: 'candidate_overview_explanation'
                        }
                    },
                    candidate_overview_explanation: {
                        entry: ['onCandidateOverviewExplanation']
                    }
                }
            }
        },
    };

    constructor() {

        this.bubbles = [];

        parent = document.querySelector(".how-it-works-mini");

        // Create images
        var img;
        img = document.createElement("img");
        img.classList.add("walkthrough-bubble");
        img.classList.add("mini");
        img.classList.add("hidden");
        img.classList.add("no-animation");
        img.setAttribute("src", "/assets/walkthrough/osm/find-home-address.png");
        parent.prepend(img);
        this.bubbles.push(img);

        this.bubble_src = [
            "/assets/walkthrough/osm/find-home-address.png",
            "/assets/walkthrough/osm/candidate-overview.png",
        ];

        this.currentBubble = this.bubbles[0];

        this.stateMachine = createMachine(OSMTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => {},
                onCandidateOverviewExplanation: (context, event) => { this.onCandidateOverviewExplanation() },
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state.value))
            .start();

        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark-container-mini");
        button.addEventListener("click", () => scope.state.send("TOGGLE"));

    }

    switchToBubble(index) {
        this.currentBubble.setAttribute("src", this.bubble_src[index]);
    }

    // Hide the tutorial window
    clear(context, event) {
        this.currentBubble.classList.add("pop-out");
    }

    // Make the tutorial window visible
    open (context, event) {
        this.currentBubble.classList.remove("hidden");
        this.currentBubble.classList.remove("pop-out");
        this.currentBubble.classList.remove("no-animation");
    }

    onCandidateOverviewExplanation(context, event) {
        console.log("onCandidateOverviewExplanation")
        this.switchToBubble(1);
    }
}

export class ElectionSearchTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden'
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {
                        on: {
                            SELECT_CANDIDATE: 'select_candidate_explanation'
                        }
                    },
                    select_candidate_explanation: {
                        entry: ['onSelectCandidateExplanation']
                    }
                }
            }
        },
    };

    constructor() {

        this.bubbles = [];

        parent = document.querySelector(".how-it-works-wrapper-mini.bubble-wrapper");

        // Create images
        var img;
        img = document.createElement("img");
        img.classList.add("walkthrough-bubble");
        img.classList.add("mini");
        img.classList.add("hidden");
        img.classList.add("no-animation");
        img.setAttribute("src", "/assets/walkthrough/elections-search/qualified-elections.png");
        parent.prepend(img);
        this.bubbles.push(img);

        this.bubble_src = [
            "/assets/walkthrough/elections-search/qualified-elections.png",
            "/assets/walkthrough/elections-search/select-a-candidate.png",
        ];

        this.currentBubble = this.bubbles[0];

        this.stateMachine = createMachine(ElectionSearchTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => {},
                onSelectCandidateExplanation: (context, event) => { this.onSelectCandidateExplanation() },
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state.value))
            .start();

        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark-container-mini");
        button.addEventListener("click", () => scope.state.send("TOGGLE"));

    }

    switchToBubble(index) {
        this.currentBubble.setAttribute("src", this.bubble_src[index]);
    }

    // Hide the tutorial window
    clear(context, event) {
        this.currentBubble.classList.add("pop-out");
    }

    // Make the tutorial window visible
    open (context, event) {
        this.currentBubble.classList.remove("hidden");
        this.currentBubble.classList.remove("pop-out");
        this.currentBubble.classList.remove("no-animation");
    }

    onSelectCandidateExplanation(context, event) {
        console.log("onSelectCandidateExplanation")
        this.switchToBubble(1);
    }
}

export class CandidatesTutorial extends OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden'
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {

                    }
                }
            }
        },
    };

    constructor() {
        super();

        document.querySelector(".how-it-works").prepend(this.bubble.element);

        this.bubble_html = [
            "Explore campaign details, watch candidate videos, follow or add a specific candidate to your ballot, donate.",
        ];

        this.stateMachine = createMachine(CandidatesTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => {},
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state.value))
            .start();

        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", () => scope.state.send("TOGGLE"))

        this.switchToBubble(0);
    }
}

export class MyBallotTutorial extends OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden'
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {

                    }
                }
            }
        },
    };

    constructor() {
        super();

        document.querySelector(".how-it-works").prepend(this.bubble.element);

        this.bubble_html = [
            "Save candidate here for a stress-free day at the polls. You can also share your ballot so others can vote for your favorite candidate too.",
        ];

        this.stateMachine = createMachine(MyBallotTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => {},
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state.value))
            .start();

        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", () => scope.state.send("TOGGLE"))
        
        this.switchToBubble(0);
    }
}

export class ElectionTutorial extends OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden'
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {

                    }
                }
            }
        },
    };

    constructor() {
        super();

        document.querySelector(".how-it-works").prepend(this.bubble.element);

        this.bubble_html = [
            "Follow an election, flip the cards, compare a group of candidates, or click on a specific candidate for more details",
        ];

        this.stateMachine = createMachine(MyBallotTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => {},
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state.value))
            .start();

        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", () => scope.state.send("TOGGLE"))

        this.switchToBubble(0);
    }
}

export class FeedTutorial extends OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden'
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {

                    }
                }
            }
        },
    };

    constructor() {
        super();

        document.querySelector(".how-it-works").prepend(this.bubble.element);

        this.bubble_html = [
            "Visit your feed to see updates to the candidates and elections you follow.",
        ];

        this.stateMachine = createMachine(FeedTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => {},
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state.value))
            .start();

        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", () => scope.state.send("TOGGLE"))

        this.switchToBubble(0);
    }
}

export class MyElectionTutorial extends OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: 'tutorial',
        type: 'parallel',
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: 'initial',
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: 'visible',
                                actions: ['open']
                            }
                        },
                        entry: ['clear'],
                    },
                    visible: {
                        on: {
                            TOGGLE: 'hidden'
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: 'first_view',
                states: {
                    first_view: {

                    }
                }
            }
        },
    };

    constructor() {
        super();

        document.querySelector(".how-it-works").prepend(this.bubble.element);

        this.bubble_html = [
            "Select a candidate to learn more about them. Verified candidates have been confirmed by Ballot Builder to be on your ballot.",
        ];

        this.stateMachine = createMachine(MyBallotTutorial.stateMachineParams, {
            actions: {
                open: (context, event) => { this.open( context, event ) },
                clear: (context, event) => { this.clear( context, event ) },
                onFirstView: (context, event) => {},
            }
        });

        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = interpret(this.stateMachine)
            .onTransition((state) => console.log("state transition:", state.value))
            .start();

        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", () => scope.state.send("TOGGLE"))

        this.switchToBubble(0);
    }
}